import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q4 = ({ history }) => {
  const { t } = useTranslation();
  const Q4Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question4')}
      options={Q4Options}
      nextUrl="q5"
      screenName="q4"
    />
  );
};

export default Q4;
